import { ApiClient } from '../../core/api/ApiClient';
import { PharmDashboardRepositoryImpl } from './implementations';
import { PharmDashboardService } from './services';

export * from './implementations';
export * from './interfaces';
export * from './services';

class PharmDashboardDomainContainer {
  constructor() {
    this._apiClient = null;
    this._repository = null;
    this._service = null;
  }

  get apiClient() {
    if (!this._apiClient) {
      const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';
      this._apiClient = new ApiClient(baseURL);
    }
    return this._apiClient;
  }

  get repository() {
    if (!this._repository) {
      this._repository = new PharmDashboardRepositoryImpl(this.apiClient);
    }
    return this._repository;
  }

  get service() {
    if (!this._service) {
      this._service = new PharmDashboardService(this.repository);
    }
    return this._service;
  }

  reset() {
    this._apiClient = null;
    this._repository = null;
    this._service = null;
  }
}

const container = new PharmDashboardDomainContainer();

export const getPharmDashboardService = () => container.service;
export const resetPharmDashboardContainer = () => container.reset();
